import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 251  -  呼叫子剧情
 */

export default class EventCallSubStory extends EventBase {
  /**
   * 呼叫子剧情构造函数
   */
  constructor() {
    super()
    this.Parameter = ['0', '']
  }

  //   // #region 事件内关键属性参数
  /**
   * 剧情ID
   */
  get MapId() {
    return parseInt(this.Parameter?.[0] ?? '')
  }
  set MapId(value) {
    this.Parameter![0] = value.toString()
  }

  /**
   * 显示内容
   */
  get Description() {
    return this.Parameter?.[1]
  }
  set Description(value) {
    this.Parameter![1] = (value ?? '').toString()
  }

  //   // #endregion

  /**
   * 事件ID
   */
  Code = EventID.CallSubStory

  /**
   * 获得该事件在事件列表的描述信息
   */
  /// <returns>事件描述信息</returns>
}
